import React, { forwardRef } from "react";
import { CardBillingProps, RefsCardBillingInfo } from "../types/address.types";
import TextInput from "../../text-input";
import SelectInput from "../../select-input";

export interface CardBillingInfoWithForwardRef
  extends React.ForwardRefExoticComponent<
    CardBillingProps & React.RefAttributes<() => RefsCardBillingInfo>
  > {}

export const CardBillingInformation = forwardRef<
  () => RefsCardBillingInfo,
  CardBillingProps
>(
  (
    {
      label = "Billing Address",
      address1,
      address2,
      city,
      state,
      zipCode,
    }: CardBillingProps,
    ref
  ): React.ReactElement => {
    const { address1Ref, address2Ref, cityRef, zipCodeRef, stateRef } =
      (ref as any)?.() || {};
    return (
      <>
        <h5 className="spark-mar-t-2">{label}</h5>
        <TextInput {...address1} ref={address1Ref} />
        <TextInput {...address2} ref={address2Ref} />
        <TextInput {...city} ref={cityRef} />
        <SelectInput {...state} ref={stateRef} />
        <div className="row">
          <div className="col-xs-12 col-md-6 col-lg-6">
            <TextInput {...zipCode} ref={zipCodeRef} />
          </div>
        </div>
      </>
    );
  }
) as CardBillingInfoWithForwardRef;

CardBillingInformation.displayName = "CardBillingInformation";
